import React from 'react';

export default function PrivacyPolicyFr() {
  return (
    <div className="doc-page">
      <div className="doc-header">
        <span className="doc-label">Confidentialité</span>
        <h1 className="doc-title">Politique de confidentialité de MegaTransact</h1>
        <p className="doc-intro">
          Comment MegaTransact collecte, utilise, protège et gère les informations personnelles.
          MegaTransact est une plateforme numérique commençant par le prêt salarial et s'étendant
          progressivement à des services financiers pratiques. Nous nous engageons à traiter les
          informations personnelles de manière responsable, sécurisée et transparente.
        </p>
        <div className="doc-meta">
          <span className="doc-meta-item">
            <strong>Date d'entrée en vigueur :</strong> 27 mars 2026
          </span>
          <span className="doc-meta-item">
            <strong>Dernière mise à jour :</strong> 27 mars 2026
          </span>
        </div>
      </div>

      <div className="doc-body">
        <div className="doc-preamble">
          <p>
            MegaTransact respecte votre vie privée et s'engage à traiter vos informations
            personnelles de manière responsable. La présente politique de confidentialité
            explique comment MegaTransact collecte, utilise, stocke, partage et protège les
            informations lorsque vous utilisez notre application, notre site web, nos canaux de
            support et nos services connexes.
          </p>
          <p>
            MegaTransact est une plateforme numérique commençant par le prêt salarial et pouvant
            s'étendre au fil du temps à d'autres services financiers et outils connexes. La
            présente politique de confidentialité s'applique à tous les utilisateurs des services
            MegaTransact, sauf si un avis de confidentialité distinct est fourni pour un service
            spécifique.
          </p>
        </div>

        {/* Qui sommes-nous */}
        <div className="doc-section">
          <h2 className="section-title">Qui sommes-nous</h2>
          <p>
            MegaTransact est une plateforme numérique conçue pour fournir un soutien financier
            structuré lié au salaire et des services numériques connexes.
          </p>
          <p>
            Si vous avez des questions sur la présente politique de confidentialité ou sur la
            manière dont vos informations sont traitées, vous pouvez nous contacter à :
          </p>
          <div className="doc-contact-box">
            <p>
              <strong>E-mail :</strong>{' '}
              <a href="mailto:admin@megablissworldwide.com">admin@megablissworldwide.com</a>
            </p>
            <p>
              <strong>Société :</strong> MegaBliss LTD
            </p>
            <p>
              <strong>Adresse :</strong> Bâtiment EIFUN, Avenue Kabalo n° 171, croisement Huilerie-Kabalo, Kinshasa, 4ᵉ niveau, bureau n° 45
            </p>
          </div>
        </div>

        {/* Informations que nous collectons */}
        <div className="doc-section">
          <h2 className="section-title">Informations que nous collectons</h2>
          <p>
            Nous pouvons collecter des informations personnelles directement auprès de vous, de
            votre employeur le cas échéant et si cela est permis, de fournisseurs de services et
            de votre utilisation de la plateforme.
          </p>
          <p>Ces informations peuvent inclure :</p>
          <ul>
            <li className="cat-item">
              <strong>Informations d'identité</strong>
              <ul>
                <li>Nom complet</li>
                <li>Date de naissance</li>
                <li>Photo de profil, le cas échéant</li>
                <li>
                  Détails d'identification tels que carte d'identité nationale, passeport,
                  numéro d'employé ou autres documents de vérification si nécessaire
                </li>
              </ul>
            </li>
            <li className="cat-item">
              <strong>Informations de contact</strong>
              <ul>
                <li>Numéro de téléphone</li>
                <li>Adresse e-mail</li>
                <li>Adresse résidentielle</li>
                <li>Coordonnées d'urgence ou alternatives le cas échéant</li>
              </ul>
            </li>
            <li className="cat-item">
              <strong>Informations sur l'emploi et le lieu de travail</strong>
              <ul>
                <li>Nom de l'employeur</li>
                <li>Titre du poste ou fonction</li>
                <li>Numéro d'employé</li>
                <li>Fourchette salariale ou informations salariales</li>
                <li>Calendrier de paiement du salaire</li>
                <li>Statut d'emploi</li>
                <li>
                  Informations relatives à la paie pertinentes pour l'éligibilité et les
                  arrangements de remboursement
                </li>
              </ul>
            </li>
            <li className="cat-item">
              <strong>Informations sur le compte et la plateforme</strong>
              <ul>
                <li>Nom d'utilisateur</li>
                <li>Identifiants de connexion</li>
                <li>Identifiants d'appareil</li>
                <li>Données d'utilisation de l'application</li>
                <li>Références de transaction</li>
                <li>Préférences du compte</li>
                <li>Historique du support</li>
              </ul>
            </li>
            <li className="cat-item">
              <strong>Informations financières et liées au remboursement</strong>
              <ul>
                <li>Montant demandé</li>
                <li>Montant approuvé</li>
                <li>Calendrier de remboursement</li>
                <li>Historique de remboursement</li>
                <li>Registres de retenues sur salaire le cas échéant</li>
                <li>Détails de versement ou de décaissement</li>
                <li>Détails des services liés aux paiements ou recouvrements</li>
              </ul>
            </li>
            <li className="cat-item">
              <strong>Informations techniques</strong>
              <ul>
                <li>Adresse IP</li>
                <li>Type de navigateur</li>
                <li>Type d'appareil</li>
                <li>Système d'exploitation mobile</li>
                <li>Paramètres de langue</li>
                <li>Dates et heures d'accès</li>
                <li>Journaux de crash et diagnostics de l'application</li>
              </ul>
            </li>
            <li className="cat-item">
              <strong>Communications</strong>
              <ul>
                <li>Messages envoyés au support client</li>
                <li>Réponses aux sondages</li>
                <li>Soumissions de commentaires</li>
                <li>Enregistrements d'appels ou de chats lorsque la loi le permet</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Comment nous utilisons vos informations */}
        <div className="doc-section">
          <h2 className="section-title">Comment nous utilisons vos informations</h2>
          <p>
            Nous utilisons les informations personnelles à des fins opérationnelles, de service,
            de sécurité et juridiques légitimes, notamment pour :
          </p>
          <ul>
            <li>Créer et gérer votre compte</li>
            <li>Vérifier votre identité le cas échéant</li>
            <li>Évaluer l'éligibilité aux services de soutien salarial</li>
            <li>Traiter les demandes et requêtes connexes</li>
            <li>Faciliter les arrangements de remboursement liés au salaire</li>
            <li>Communiquer avec vous au sujet de votre compte ou de vos demandes</li>
            <li>Fournir un support client</li>
            <li>Améliorer les performances de l'application et l'expérience utilisateur</li>
            <li>Surveiller l'utilisation du service et prévenir les abus</li>
            <li>Maintenir les registres et les rapports internes</li>
            <li>
              Se conformer aux obligations légales, réglementaires, contractuelles et de gestion
              des risques
            </li>
            <li>
              Enquêter sur la fraude, les abus, les problèmes de sécurité ou les violations de
              politique
            </li>
            <li>Développer et améliorer les services actuels et futurs</li>
          </ul>
        </div>

        {/* Base juridique du traitement */}
        <div className="doc-section">
          <h2 className="section-title">Base juridique du traitement</h2>
          <p>
            Lorsque la loi applicable l'exige, nous traitons les informations personnelles sur
            un ou plusieurs des fondements suivants :
          </p>
          <ul>
            <li>Votre consentement</li>
            <li>
              L'exécution d'un contrat ou les mesures prises à votre demande avant la conclusion
              d'un contrat
            </li>
            <li>Le respect d'obligations légales ou réglementaires</li>
            <li>
              Les intérêts légitimes tels que l'amélioration des services, la prévention de la
              fraude, la sécurité de la plateforme et les opérations responsables
            </li>
          </ul>
        </div>

        {/* Informations des employeurs */}
        <div className="doc-section">
          <h2 className="section-title">
            Informations des employeurs et partenaires de travail
          </h2>
          <p>
            Étant donné que MegaTransact commence par le prêt salarial, certaines informations
            peuvent être reçues des employeurs ou des partenaires de travail lorsque cela est
            nécessaire et légal.
          </p>
          <p>
            Ces informations peuvent inclure la confirmation de l'emploi, les détails liés au
            salaire, le statut de remboursement ou les données relatives à la paie nécessaires
            pour administrer le service.
          </p>
          <p>
            MegaTransact s'attend à ce que les partenaires de travail ne partagent que les
            informations nécessaires au service concerné et le fassent conformément à la loi
            applicable et à leurs propres obligations envers le personnel.
          </p>
        </div>

        {/* Comment nous partageons les informations */}
        <div className="doc-section">
          <h2 className="section-title">Comment nous partageons les informations</h2>
          <p>Nous ne vendons pas vos informations personnelles.</p>
          <p>
            Nous pouvons partager des informations uniquement lorsque cela est raisonnablement
            nécessaire, y compris avec :
          </p>
          <ul>
            <li>
              Les employeurs ou partenaires de paie impliqués dans les arrangements liés au
              salaire
            </li>
            <li>Les processeurs de paiement ou partenaires de versement</li>
            <li>Les fournisseurs de vérification d'identité</li>
            <li>Les fournisseurs d'hébergement et de services cloud</li>
            <li>Les fournisseurs d'analyse et de services techniques</li>
            <li>
              Les conseillers professionnels tels que les avocats, auditeurs ou consultants en
              conformité
            </li>
            <li>
              Les régulateurs, tribunaux, forces de l'ordre ou autorités publiques lorsque la
              loi l'exige
            </li>
            <li>
              Les investisseurs potentiels, acquéreurs ou parties de restructuration, de manière
              limitée et appropriée, si MegaTransact subit une transition commerciale
            </li>
          </ul>
          <p>
            Tout partage sera limité à ce qui est raisonnablement nécessaire pour l'objectif
            concerné.
          </p>
        </div>

        {/* Conservation des données */}
        <div className="doc-section">
          <h2 className="section-title">Conservation des données</h2>
          <p>
            MegaTransact conserve les informations personnelles uniquement aussi longtemps que
            nécessaire pour les fins décrites dans la présente politique de confidentialité, y
            compris pour la prestation de services, la tenue de registres, la résolution de
            litiges, la prévention de la fraude et la conformité légale ou réglementaire.
          </p>
          <p>Les périodes de conservation peuvent varier en fonction de :</p>
          <ul>
            <li>La nature des informations</li>
            <li>Le service fourni</li>
            <li>Les exigences légales</li>
            <li>Les obligations comptables et d'audit</li>
            <li>Les besoins de prévention de la fraude</li>
            <li>Les considérations de litige ou d'exécution</li>
          </ul>
          <p>
            Lorsque les informations ne sont plus nécessaires, nous les supprimerons, les
            anonymiserons ou les stockerons de manière sécurisée uniquement lorsque la
            conservation continue est légalement nécessaire.
          </p>
        </div>

        {/* Sécurité des données */}
        <div className="doc-section">
          <h2 className="section-title">Sécurité des données</h2>
          <p>
            MegaTransact prend des mesures techniques, administratives et organisationnelles
            raisonnables pour protéger les informations personnelles contre l'accès non autorisé,
            la perte, l'utilisation abusive, l'altération ou la divulgation.
          </p>
          <p>Ces mesures peuvent inclure :</p>
          <ul>
            <li>Contrôles d'accès</li>
            <li>Chiffrement le cas échéant</li>
            <li>Stockage sécurisé</li>
            <li>Journaux d'audit</li>
            <li>Obligations de confidentialité du personnel</li>
            <li>Accès limité basé sur les rôles</li>
            <li>Surveillance des activités suspectes</li>
          </ul>
          <p>
            Cependant, aucune méthode de transmission ou de stockage n'est totalement sécurisée,
            et MegaTransact ne peut garantir une sécurité absolue.
          </p>
        </div>

        {/* Transferts internationaux de données */}
        <div className="doc-section">
          <h2 className="section-title">Transferts internationaux de données</h2>
          <p>
            Vos informations peuvent être stockées ou traitées dans des pays autres que le vôtre,
            y compris là où MegaTransact ou ses fournisseurs de services exploitent des
            infrastructures ou des fonctions de support.
          </p>
          <p>
            Lorsque des informations personnelles sont transférées au-delà des frontières,
            MegaTransact prendra des mesures raisonnables pour garantir que des garanties
            appropriées sont en place et que les informations continuent de recevoir un niveau
            de protection approprié.
          </p>
        </div>

        {/* Vos droits */}
        <div className="doc-section">
          <h2 className="section-title">Vos droits</h2>
          <p>
            Selon la loi qui vous est applicable, vous pouvez avoir le droit de :
          </p>
          <ul>
            <li>Demander l'accès à vos informations personnelles</li>
            <li>Demander la correction d'informations inexactes ou incomplètes</li>
            <li>Demander la suppression de certaines informations</li>
            <li>Vous opposer à certains traitements</li>
            <li>Demander la limitation du traitement</li>
            <li>Retirer votre consentement lorsque le traitement dépend du consentement</li>
            <li>Demander le transfert de vos informations le cas échéant</li>
            <li>Déposer une plainte auprès d'une autorité de protection des données compétente</li>
          </ul>
          <p>
            Ces droits ne sont pas absolus et peuvent être limités par la loi, les obligations
            contractuelles ou les exigences opérationnelles légitimes.
          </p>
          <p>Pour exercer vos droits, contactez-nous à :</p>
          <div className="doc-contact-box">
            <p>
              <a href="mailto:admin@megablissworldwide.com">admin@megablissworldwide.com</a>
            </p>
          </div>
        </div>

        {/* Cookies */}
        <div className="doc-section">
          <h2 className="section-title">Cookies et technologies similaires</h2>
          <p>
            MegaTransact peut utiliser des cookies, le stockage de l'appareil, des outils
            d'analyse et des technologies similaires sur son site web ou son application pour :
          </p>
          <ul>
            <li>Maintenir les utilisateurs connectés le cas échéant</li>
            <li>Mémoriser les préférences</li>
            <li>Comprendre l'utilisation du service</li>
            <li>Améliorer la fonctionnalité et la stabilité</li>
            <li>Soutenir la sécurité et la prévention de la fraude</li>
          </ul>
          <p>
            Vous pouvez contrôler certaines de ces technologies via les paramètres de votre
            navigateur ou de votre appareil.
          </p>
        </div>

        {/* Protection des enfants */}
        <div className="doc-section">
          <h2 className="section-title">Protection des enfants</h2>
          <p>
            Les services MegaTransact ne sont pas destinés aux enfants sauf indication expresse
            contraire. Nous ne collectons pas sciemment des informations personnelles d'enfants
            en violation de la loi applicable.
          </p>
          <p>
            Si nous apprenons que de telles informations ont été collectées de manière
            inappropriée, nous prendrons des mesures raisonnables pour les supprimer.
          </p>
        </div>

        {/* Services tiers */}
        <div className="doc-section">
          <h2 className="section-title">Services tiers</h2>
          <p>
            MegaTransact peut s'appuyer sur des fournisseurs tiers pour l'hébergement, la
            messagerie, la vérification, l'analyse, le support de paiement ou les opérations
            techniques connexes.
          </p>
          <p>
            Lorsque vous interagissez avec des outils ou des liens tiers, leurs propres pratiques
            de confidentialité peuvent également s'appliquer. MegaTransact n'est pas responsable
            des pratiques de confidentialité des services tiers indépendants échappant à son
            contrôle.
          </p>
        </div>

        {/* Prévention de la fraude */}
        <div className="doc-section">
          <h2 className="section-title">Prévention de la fraude et utilisation responsable</h2>
          <p>
            MegaTransact peut utiliser des informations personnelles et techniques pour détecter
            la fraude, l'utilisation abusive, les comptes en double, les soumissions fausses, la
            manipulation des processus de service ou les menaces de sécurité.
          </p>
          <p>
            Cela est nécessaire pour protéger les utilisateurs, les employeurs, les partenaires
            et l'intégrité de la plateforme.
          </p>
        </div>

        {/* Modifications */}
        <div className="doc-section">
          <h2 className="section-title">Modifications de la présente politique de confidentialité</h2>
          <p>
            MegaTransact peut mettre à jour la présente politique de confidentialité de temps à
            autre pour refléter les évolutions des services, les exigences légales ou les
            améliorations opérationnelles.
          </p>
          <p>
            Lorsque nous apportons des modifications importantes, nous prendrons des mesures
            raisonnables pour informer les utilisateurs de manière appropriée, par exemple via
            l'application, le site web ou d'autres canaux de communication.
          </p>
          <p>
            La version mise à jour entrera en vigueur à la date indiquée en haut de la politique.
          </p>
        </div>

        {/* Nous contacter */}
        <div className="doc-section">
          <h2 className="section-title">Nous contacter</h2>
          <p>
            Si vous avez des questions, des demandes ou des préoccupations concernant la présente
            politique de confidentialité ou la manière dont MegaTransact traite les informations
            personnelles, veuillez contacter :
          </p>
          <div className="doc-contact-box">
            <p>
              <strong>MegaTransact</strong>
            </p>
            <p>
              <strong>E-mail :</strong>{' '}
              <a href="mailto:admin@megablissworldwide.com">admin@megablissworldwide.com</a>
            </p>
            <p>
              <strong>Société :</strong> MegaBliss LTD
            </p>
            <p>
              <strong>Adresse :</strong> Bâtiment EIFUN, Avenue Kabalo n° 171, croisement Huilerie-Kabalo, Kinshasa, 4ᵉ niveau, bureau n° 45
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
